export const jobsData = [
  {
    id: 2,
    title: "Digital Assets Trader",
    location: "Netherlands",
    type: "Trading",
    level: "Mid-level",
    company: "Flow Traders",
    logo: "https://www.flowtraders.com/media/4q4ht1x1/logo.png", // Optional: add logo URL or leave it out
    url: "https://www.flowtraders.com/careers/job-description/3234877"
  },
  {
    id: 3,
    title: "Graduate Quantitative Trader",
    location: "Netherlands",
    type: "Trading",
    level: "Junior",
    company: "All Options",
    url: "https://www.alloptions-international.com/vacancies/graduate-quantitative-trader-2/"
  },
  {
    id: 4,
    title: "Career Kickstarter: Trading 2026",
    location: "Netherlands",
    type: "Trading",
    level: "Junior",
    company: "Optiver",
    logo: "https://optiver.com/wp-content/uploads/2024/03/Mainlogo-Black_RGB.svg", // Optional: add logo URL or leave it out
    url: "https://optiver.com/working-at-optiver/career-opportunities/8177218002/"
  },
  {
    id: 1,
    title: "Graduate Trader",
    location: "Netherlands",
    type: "Trading",
    level: "Junior",
    company: "UTR8 GROUP",
    logo: "https://utr8-group.com/utr8logo.png", // Optional: add logo URL or leave it out
    url: "https://utr8-group.com/#careers/1"
  },
  {
    id: 5,
    title: "Quantitative Trading Internship",
    location: "Taiwan",
    type: "Trading",
    level: "Junior",
    company: "Optiver",
    logo: "https://optiver.com/wp-content/uploads/2024/03/Mainlogo-Black_RGB.svg", // Optional: add logo URL or leave it out
    url: "https://optiver.com/working-at-optiver/career-opportunities/8011956002/"
  },
  {
    id: 6,
    title: "Equity Analyst",
    location: "India",
    type: "Research",
    level: "Mid-level",
    company: "Optiver",
    logo: "https://optiver.com/wp-content/uploads/2024/03/Mainlogo-Black_RGB.svg", // Optional: add logo URL or leave it out
    url: "https://optiver.com/working-at-optiver/career-opportunities/7752050002/"
  },
  {
  id: 7,
  title: "Fixed Income Trader",
  location: "Australia",
  type: "Trading",
  level: "Mid-level",
  company: "Nine Mile",
  url: "https://www.nmftrading.com/job/fixed-income-trader/"
  },
  {
  id: 8,
  title: "Delta 1 Trader",
  location: "Australia",
  type: "Trading",
  level: "Mid-level",
  company: "Nine Mile",
  url: "https://www.nmftrading.com/job/delta-1-trader/"
  },
  {
  id: 9,
  title: "Quantitative Trader",
  location: "Hong Kong",
  type: "Trading",
  level: "Junior",
  company: "Jane Street",
  logo: "https://www.janestreet.com/assets/logo_horizontal-16929188a56384c8e77bea91967c4553146ed7293f60a8f4f2ab6a06187881ce.svg",
  url: "https://www.janestreet.com/join-jane-street/position/8071940002/"
  },
  {
  id: 10,
  title: "Quantitative Researcher",
  location: "Hong Kong",
  type: "Research",
  level: "Junior",
  company: "Jane Street",
  logo: "https://www.janestreet.com/assets/logo_horizontal-16929188a56384c8e77bea91967c4553146ed7293f60a8f4f2ab6a06187881ce.svg",
  url: "https://www.janestreet.com/join-jane-street/position/8071941002/"
  },
  {
  id: 11,
  title: "Quantitative Trader",
  location: "United Kingdom",
  type: "Trading",
  level: "Junior",
  company: "Jane Street",
  logo: "https://www.janestreet.com/assets/logo_horizontal-16929188a56384c8e77bea91967c4553146ed7293f60a8f4f2ab6a06187881ce.svg",
  url: "https://www.janestreet.com/join-jane-street/position/8092062002/"
  },
  {
  id: 12,
  title: "Quantitative Researcher",
  location: "United Kingdom",
  type: "Research",
  level: "Junior",
  company: "Jane Street",
  logo: "https://www.janestreet.com/assets/logo_horizontal-16929188a56384c8e77bea91967c4553146ed7293f60a8f4f2ab6a06187881ce.svg",
  url: "https://www.janestreet.com/join-jane-street/position/8092053002/"
  },
  {
  id: 13,
  title: "Quantitative Trader",
  location: "United States",
  type: "Trading",
  level: "Junior",
  company: "Jane Street",
  logo: "https://www.janestreet.com/assets/logo_horizontal-16929188a56384c8e77bea91967c4553146ed7293f60a8f4f2ab6a06187881ce.svg",
  url: "https://www.janestreet.com/join-jane-street/position/8070482002/"
  },
  {
  id: 14,
  title: "Quantitative Researcher",
  location: "United States",
  type: "Research",
  level: "Junior",
  company: "Jane Street",
  logo: "https://www.janestreet.com/assets/logo_horizontal-16929188a56384c8e77bea91967c4553146ed7293f60a8f4f2ab6a06187881ce.svg",
  url: "https://www.janestreet.com/join-jane-street/position/8069351002/"
  },
  {
  id: 15,
  title: "Graduate Trader",
  location: "Netherlands",
  type: "Trading",
  level: "Junior",
  company: "Da Vinci",
  logo: "https://davincitrading.com/wp-content/uploads/2025/02/DaVinci-Trading-logo-icon-purple.svg",
  url: "https://davincitrading.com/job/graduate-trader/"
  },
  {
  id: 16,
  title: "Quantitative Researcher",
  location: "Ireland",
  type: "Research",
  level: "Junior",
  company: "Susquehanna",
  logo: "https://cdn.phenompeople.com/CareerConnectResources/SUSQA004Y/images/255_black_logo-1730212493063.png",
  url: "https://careers.sig.com/job/9553/Quantitative-Researcher-Graduate-2026"
  },
  {
  id: 17,
  title: "Quantitative Systematic Trader",
  location: "Ireland",
  type: "Trading",
  level: "Junior",
  company: "Susquehanna",
  logo: "https://cdn.phenompeople.com/CareerConnectResources/SUSQA004Y/images/255_black_logo-1730212493063.png",
  url: "https://careers.sig.com/job/9551/Quantitative-Systematic-Trader-Graduate-2026"
  },
  {
  id: 18,
  title: "Quantitative Systematic Trader",
  location: "United States",
  type: "Trading",
  level: "Junior",
  company: "Susquehanna",
  logo: "https://cdn.phenompeople.com/CareerConnectResources/SUSQA004Y/images/255_black_logo-1730212493063.png",
  url: "https://careers.sig.com/job/9442/Quantitative-Systematic-Trader-Master-s-2026"
  },
  {
  id: 19,
  title: "Graduate Quantitative Trader",
  location: "Australia",
  type: "Trading",
  level: "Junior",
  company: "Susquehanna",
  logo: "https://cdn.phenompeople.com/CareerConnectResources/SUSQA004Y/images/255_black_logo-1730212493063.png",
  url: "https://careers.sig.com/job/9688/Graduate-Quantitative-Trader-2027"
  },
  {
  id: 20,
  title: "Quantitative Trader",
  location: "Singapore",
  type: "Trading",
  level: "Mid-level",
  company: "DRW",
  url: "https://www.drw.com/work-at-drw/listings/quantitative-trader-3288038"
  },
  {
  id: 21,
  title: "Crude Oil Options Trader",
  location: "United States",
  type: "Trading",
  level: "Mid-level",
  company: "DRW",
  url: "https://www.drw.com/work-at-drw/listings/crude-oil-options-trader-3223670"
  },
];